import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eaf2e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment__top" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "comment__user-name" }
const _hoisted_4 = {
  key: 0,
  class: "comment__stars"
}
const _hoisted_5 = { class: "comment__star" }
const _hoisted_6 = { class: "comment__bottom" }
const _hoisted_7 = { class: "comment__content-container" }
const _hoisted_8 = { class: "comment__date" }
const _hoisted_9 = { class: "comment-box" }
const _hoisted_10 = { class: "comment__comment" }
const _hoisted_11 = ["data-like"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "comment" }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "comment__image",
        width: "40",
        height: "40",
        src: _ctx.userImage,
        onError: _cache[0] || (_cache[0] = 
          event =>
            (event.target.src = require('../../assets/static/icons/onerror-user.png'))
        ),
        alt: ""
      }, null, 40, _hoisted_2),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userName), 1),
      (_ctx.stars)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stars, (star) => {
              return (_openBlock(), _createElementBlock("span", _hoisted_5))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.toLocaleDateTime(_ctx.date)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.comment ? _ctx.comment : ""), 1),
        (_ctx.tab === 'Ratings')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(['button-like', { outlined: _ctx.isLiked() }]),
              "data-like": _ctx.id,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
            }, _toDisplayString(_ctx.likes.length), 11, _hoisted_11))
          : _createCommentVNode("", true)
      ]),
      (_ctx.userID === _ctx.user.id)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "delete-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteRating()))
          }, "Excluir"))
        : _createCommentVNode("", true)
    ])
  ], 16))
}